import {observer} from 'mobx-react-lite'
import React, {useEffect, useState} from 'react'
import {
  useTaskStore
} from '@components/my-tasks/tasks-list/task-store'
import {StickerItem} from '@components/sticker'
import {globals} from '@extensions/globals-base'

export const TaskUsersColumn = observer(() => {
  const [state, store] = useTaskStore()
  const [isMenuOpened, setIsMenuOpened] = useState(false)

  useEffect(() => {
    const currentUser = globals.currentUserId

    if (!state?.assignedUsers?.includes(currentUser)) {
      setIsMenuOpened(false)
    }
  }, [state?.assignedUsers])

  if (!store || !state) {
    return null;
  }

  return (
    <div
      onClick={event => {
        event.stopPropagation()
        setIsMenuOpened(true)
      }}
    >
      {store.usersSticker && (
        <StickerItem
          draggable
          withTooltip
          withMenu
          menuIsOpened={isMenuOpened}
          sticker={store.usersSticker}
          location="task"
          taskId={state.taskId}
        />
      )}
    </div>
  )
})
